import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserDispatcherList from "./user-dispatcher-list";
import UserDispatcherListError from "./user-dispatcher-list-error";
import UserDispatcherListParams from "./user-dispatcher-list-params";

const useDispatcherList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserDispatcherList>({ data: [], totalCount: 0 });

  const load = async (
    params: UserDispatcherListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await userService.getDispatcherList(params, signal);

      setData(data);
      setIsLoading(false);
    } catch (_error) {
      const error = _error as UserDispatcherListError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDispatcherList;
